import { get } from '../../../utils/api'

interface Counter {
  id: number
  code: string
  description: string
  isEnabled: boolean
  threshold: number
  currentValue: number
}

const fetchCounter = () =>
  get<Counter[]>(`/licensing/counters/?code=MAX_DOWNLOADS`)
    .then((data) => {
      if (data.length > 0) {
        return data[0]
      }
      return undefined
    })
    .catch(() => undefined)

export { fetchCounter }
